import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import "../css/others/Table.css";
import Pagination from "../Reusablecomponents/Pagination";
import "../css/others/Popup.css";
import { apiCall } from "../main/ApiCall";
import ToastPopup from "../popups/ToastPopup";
import { buildUserPayload } from "../main/buildUserPayload";
import { createToastMessage, ToastMessage, UnAssignedProject } from '../interFaces/interfaces';
import EncryptionUtils from "../main/encryptionUtils";
const AddProject: React.FC = () => {
  const [projects, setProjects] = useState<UnAssignedProject[]>([]);
  const [selectedProjects, setSelectedProjects] = useState<string[]>([]);
  const [selectAll, setSelectAll] = useState(false);
  const [, setLoading] = useState(true);
  const [message, setMessage] = useState<ToastMessage | null>(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [totalElements, setTotalElements] = useState(0);
  const [totalPages, setTotalPages] = useState<number>(0);
  const [showCommentPopup, setShowCommentPopup] = useState(false);
  const [comments, setComments] = useState("");
  const location = useLocation();
  const campaignId = location.state?.campaignId;
  const clientId = localStorage.getItem("clientId");
  const email = localStorage.getItem("email");
  const { roleName } = EncryptionUtils.getAuthInfo();
  useEffect(() => {
    const fetchProjects = async () => {
      setLoading(true);
      try {
        const payload = buildUserPayload();
        const requestBody = [{ field: "isAvailable", operator: "=", value: "true" }, { field: "clientId", operator: "=", value: clientId }, { field: "status", operator: "=", value: "Active" }, ...(payload ? [payload] : [])];
        const response = await apiCall("post", `/api/projects/search?page=${currentPage - 1}&size=${itemsPerPage}`, requestBody);
        setProjects(response?.content || []);
        setTotalElements(response?.totalElements || 0);
        setTotalPages(response.totalPages || 0);
      } catch (error) {
        console.error("Error fetching projects:", error);
        setProjects([]);
      } finally {
        setLoading(false);
      }
    };
    fetchProjects();
  }, [currentPage, itemsPerPage, clientId]);
  useEffect(() => {
    setSelectAll(projects.length > 0 && projects.every((project) => selectedProjects.includes(project.projectId)));
  }, [projects, selectedProjects]);
  const handleCheckboxChange = (projectId: string) => {
    setSelectedProjects((prevSelected) => prevSelected.includes(projectId) ? prevSelected.filter((id) => id !== projectId) : [...prevSelected, projectId]);
  };
  const handleSelectAllChange = () => {
    if (!selectAll) {
      setSelectedProjects(projects.map((project) => project.projectId));
    } else {
      setSelectedProjects([]);
    }
    setSelectAll(!selectAll);
  };
  const handleSubmitClick = () => {
    if (selectedProjects.length === 0) {
      setMessage(createToastMessage("Please select at least one project.", "warning", 3000));
      return;
    }
    setShowCommentPopup(true);
  };
  const handleSubmit = async () => {
    try {
      await apiCall("post", "/api/campaign-projects/assign", { campaignId, projectIds: selectedProjects, remark: comments, updatedBy: email });
      setMessage(createToastMessage("Projects assigned successfully!", "success", 2800));
      setTimeout(() => window.location.reload(), 3000);
      setShowCommentPopup(false);
    } catch (error: any) {
      const errorMessage = error?.response?.data?.message;
      setMessage(createToastMessage(errorMessage, "error", 3000));
      setShowCommentPopup(false);
    }
  };
  const formatDate = (dateString?: string): string => {
    if (!dateString) return "";
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return "";
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };
  return (
    <div className="table-details">
      <div className="table-title">
        <h2>Unassigned Project List</h2>
        <div className="table-title-actions">
          {["Quality Consultant"].includes(roleName) && (<button className="addbtn" onClick={handleSubmitClick}>Include Project</button>)}
        </div>
      </div>
      <div className="table-container">
        <div className="table-inner-container">
          <table className="main-table">
            <thead>
              <tr>{["Quality Consultant"].includes(roleName) && (
                <th><input type="checkbox" checked={selectAll} onChange={handleSelectAllChange} /></th>)}<th>Project ID</th><th>Project Name</th><th>Project Manager Name</th><th>Project Start Date</th><th>Project End Date</th>
              </tr>
            </thead>
            <tbody>
              {projects.length > 0 ? (
                projects.map((project) => (
                  <tr key={project.projectId}>{["Quality Consultant"].includes(roleName) && (
                    <td><input type="checkbox" checked={selectedProjects.includes(project.projectId)} onChange={() => handleCheckboxChange(project.projectId)} /></td>)}
                    <td>{project.projectId || "N/A"}</td>
                    <td>{project.projectName || "N/A"}</td>
                    <td>{project.projectManagerName || "N/A"}</td>
                    <td>{formatDate(project.projectStartDate) || "N/A"}</td>
                    <td>{formatDate(project.projectEndDate) || "N/A"}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={6} className="no-data">There are no unassigned projects.</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
      <Pagination currentPage={currentPage} totalPages={totalPages} totalElements={totalElements} itemsPerPage={itemsPerPage} onPageChange={setCurrentPage} onItemsPerPageChange={setItemsPerPage} />
      {showCommentPopup && (
        <div className="review-overlay">
          <div className="review-content">
            <h3>Include Projects</h3>
            <p>Please provide a comments for Include these projects:</p>
            <textarea value={comments} onChange={(e) => setComments(e.target.value)} placeholder="Enter your comments here..." rows={5} />
            <div className="buttons">
              <button className="cancelbutton" onClick={() => setShowCommentPopup(false)}>Cancel</button>
              <button className="savebutton" onClick={handleSubmit}>Submit</button>
            </div>
          </div>
        </div>
      )}
      {message && (<ToastPopup message={message.text} type={message.type} duration={message.duration} onClose={() => setMessage(null)} />)}
    </div>
  );
};
export default AddProject;